import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(regionId, email) {
  return yield oncallFetch("/api/oncall/partners/regions/emails/add", {
    regionId,
    email,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/regions/emails/add.js